import { Component } from '@angular/core';

@Component({
    selector: 'ups-list-footer-controls',
    template: require('./ups-list-footer-controls.component.html')
})
/** ups-list-footer-controls component*/
export class UpsListFooterControlsComponent {
    /** ups-list-footer-controls ctor */
    constructor() {

    }
}